// Module
var code = "<section id=\"banner\"> <div class=\"kov-theme-banner\" style=\"background:linear-gradient(rgba(0,0,0,.2),rgba(0,0,0,.5)),url('../../../../assets/images/kov-pro_topbg03.png')\"> <h1></h1> </div> </section> <section> <center><h1>500</h1></center> <center>Er loopt iets mis.</center> </section>";
// Exports
module.exports = code;